import { getCalApi } from '@calcom/embed-react';
import { Calendar, Plus } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { useThemeStore } from '@/Domain/store/theme.store';

export const OnboardingActionCards = () => {
  const { t } = useTranslation(['onboarding_progress', 'sidebar_menu']);
  const getResolvedTheme = useThemeStore((state) => state.getResolvedTheme);

  const openDemoCall = useCallback(async () => {
    // Static import (not `await import(...)`): the dynamic-import variant
    // makes Vite code-split `@calcom/embed-react` and emit
    // `<link rel="modulepreload/stylesheet">` hints for the chunk's deps.
    // Those hints use Vite's `base: '/'` which resolves to the app origin
    // — not the static CDN — so they 404 in production and Vite's
    // preload helper rejects the `import()` promise on the first click.
    // The package declares `sideEffects: false` and has no top-level
    // `window.Cal` init, so inlining the import is free. Do NOT revert
    // this to dynamic import. See AutomaticOnboarding.tsx for the same
    // rationale and a longer write-up.
    const cal = await getCalApi();
    // Match the app theme so the Cal.com modal doesn't jar against a
    // dark-mode page (same pattern used in the Getting Started flow).
    cal('ui', { theme: getResolvedTheme() });
    cal('modal', { calLink: 'team/quickchatai/product-demo' });
  }, [getResolvedTheme]);

  // Mirror SidebarAIAssistantSwitcher.handleCreate: hard nav for a fresh app shell.
  const openAddNewAgent = useCallback(() => {
    window.location.replace('/add_new_ai/');
  }, []);

  return (
    <div className="flex items-center gap-2 px-4" data-testid="onboarding-action-cards">
      <Button
        variant="link"
        size="md"
        onClick={openDemoCall}
        className="flex-1"
        data-testid="book-demo-button"
      >
        <Calendar className="h-4 w-4" />
        {t('onboarding_progress:complete_actions.book_demo')}
      </Button>
      <Button
        variant="link"
        size="md"
        onClick={openAddNewAgent}
        className="flex-1"
        data-testid="add-new-ai-agent-button"
      >
        <Plus className="h-4 w-4" />
        {t('sidebar_menu:button.add_ai_agent')}
      </Button>
    </div>
  );
};
